export default {
  'pages.layouts.userLayout.title':
    'Ant Design là bộ quy chuẩn thiết kế web có ảnh hưởng nhất tại VNHW',
  'pages.login.accountLogin.tab': 'Đăng nhập bằng tài khoản',
  'pages.login.accountLogin.errorMessage': 'Tên đăng nhập/mật khẩu không đúng (admin/ant.design)',
  'pages.login.failure': 'Đăng nhập thất bại, vui lòng thử lại!',
  'pages.login.success': 'Đăng nhập thành công!',
  'pages.login.username.placeholder': 'Tên đăng nhập: admin hoặc user',
  'pages.login.username.required': 'Vui lòng nhập tên đăng nhập!',
  'pages.login.password.placeholder': 'Mật khẩu: ant.design',
  'pages.login.password.required': 'Vui lòng nhập mật khẩu!',
  'pages.login.phoneLogin.tab': 'Đăng nhập bằng điện thoại',
  'pages.login.phoneLogin.errorMessage': 'Mã xác minh không đúng',
  'pages.login.phoneNumber.placeholder': 'Số điện thoại',
  'pages.login.phoneNumber.required': 'Vui lòng nhập số điện thoại!',
  'pages.login.phoneNumber.invalid': 'Số điện thoại không hợp lệ!',
  'pages.login.captcha.placeholder': 'Mã xác minh',
  'pages.login.captcha.required': 'Vui lòng nhập mã xác minh!',
  'pages.login.phoneLogin.getVerificationCode': 'Lấy mã',
  'pages.getCaptchaSecondText': 'giây',
  'pages.login.rememberMe': 'Ghi nhớ đăng nhập',
  'pages.login.forgotPassword': 'Quên mật khẩu?',
  'pages.login.submit': 'Đăng nhập',
  'pages.login.loginWith': 'Đăng nhập bằng:',
  'pages.login.registerAccount': 'Đăng ký tài khoản',
  'pages.welcome.link': 'Chào mừng',
  'pages.welcome.alertMessage': 'Các thành phần mạnh mẽ và hiệu suất cao đã được phát hành.',
  'pages.404.subTitle': 'Xin lỗi, trang bạn truy cập không tồn tại.',
  'pages.404.buttonText': 'Về trang chủ',
  'pages.admin.subPage.title': 'Trang này chỉ dành cho Admin',
  'pages.admin.subPage.alertMessage':
    'Umi UI đã được phát hành, hãy chạy "npm run ui" để trải nghiệm.',
  'pages.searchTable.createForm.newRule': 'Tạo quy tắc mới',
  'pages.searchTable.updateForm.ruleConfig': 'Cấu hình quy tắc',
  'pages.searchTable.updateForm.basicConfig': 'Thông tin cơ bản',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Tên quy tắc',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Vui lòng nhập tên quy tắc!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Mô tả quy tắc',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': 'Vui lòng nhập ít nhất 5 ký tự',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Vui lòng nhập mô tả quy tắc ít nhất 5 ký tự!',
  'pages.searchTable.updateForm.ruleProps.title': 'Cấu hình thuộc tính',
  'pages.searchTable.updateForm.object': 'Đối tượng giám sát',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Mẫu quy tắc',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Loại quy tắc',
  'pages.searchTable.updateForm.schedulingPeriod.title': 'Thiết lập chu kỳ lập lịch',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Thời gian bắt đầu',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': 'Vui lòng chọn thời gian bắt đầu!',
  'pages.searchTable.schedulingPeriod.title': 'Thiết lập chu kỳ lập lịch',
  'pages.searchTable.titleDesc': 'Mô tả',
  'pages.searchTable.ruleName': 'Cần nhập tên quy tắc',
  'pages.searchTable.titleCallNo': 'Số lượt gọi dịch vụ',
  'pages.searchTable.titleStatus': 'Trạng thái',
  'pages.searchTable.nameStatus.default': 'mặc định',
  'pages.searchTable.nameStatus.running': 'đang chạy',
  'pages.searchTable.nameStatus.online': 'trực tuyến',
  'pages.searchTable.nameStatus.abnormal': 'bất thường',
  'pages.searchTable.titleUpdatedAt': 'Lập lịch lần cuối lúc',
  'pages.searchTable.updatedAt': 'Cập nhật lúc',
  'pages.searchTable.exception': 'Vui lòng nhập lý do ngoại lệ!',
  'pages.searchTable.titleOption': 'Tùy chọn',
  'pages.searchTable.config': 'Cấu hình',
  'pages.searchTable.update': 'Cập nhật',
  'pages.searchTable.clone': 'Sao chép',
  'pages.searchTable.subscribeAlert': 'Đăng ký cảnh báo',
  'pages.searchTable.title': 'Biểu mẫu truy vấn',
  'pages.searchTable.new': 'Tạo mới',
  'pages.searchTable.chosen': 'đã chọn',
  'pages.searchTable.item': 'mục',
  'pages.searchTable.totalServiceCalls': 'Tổng số lượt gọi dịch vụ',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'Xóa hàng loạt',
  'pages.searchTable.batchApproval': 'Duyệt hàng loạt',
  'pages.searchTable.delete': 'Xóa',
  'pages.bomSpec.code': 'Mã',
  'pages.bomSpec.name': 'Tên',
  'pages.bomSpec.isActive': 'Đang hoạt động',
  'pages.bomSpec.type': 'Loại thông số',
  'pages.bomSpec.type.weaveStyle': 'Kiểu đan',
  'pages.bomSpec.type.paintingStyle': 'Loại sơn',
  'pages.bomSpec.updatedAt': 'Cập nhật lúc',
  'pages.bomSpec.createForm.title': 'Tạo mới thông số BOM',
  'pages.bomSpec.updateForm.title': 'Cập nhật thông số BOM',
  'pages.itemType.code': 'Mã',
  'pages.itemType.name': 'Tên',
  'pages.itemType.isActive': 'Đang hoạt động',
  'pages.itemType.updatedAt': 'Cập nhật lúc',
  'pages.itemType.createForm.title': 'Tạo mới loại sản phẩm',
  'pages.itemType.updateForm.title': 'Cập nhật loại sản phẩm',
  'pages.item.code': 'Mã',
  'pages.item.name': 'Tên',
  'pages.item.itemTypeId': 'Loại sản phẩm',
  'pages.item.imageUrl': 'Hình ảnh',
  'pages.item.isActive': 'Đang hoạt động',
  'pages.item.updatedAt': 'Cập nhật lúc',
  'pages.item.createForm.title': 'Tạo mới sản phẩm',
  'pages.item.updateForm.title': 'Cập nhật thông tin sản phẩm/vật tư',
  'pages.item.details': 'Chi tiết',
  'pages.item.delete.confirm': 'Bạn có chắc chắn muốn xóa?',
  'pages.item.delete.ok': 'Xóa',
  'pages.item.delete.cancel': 'Hủy',
  'pages.item.create': 'Tạo mới',
  'pages.item.update': 'Cập nhật',
  'pages.item.cancel': 'Hủy',
  'pages.item.code.required': 'Vui lòng nhập mã',
  'pages.item.name.required': 'Vui lòng nhập tên',
  'pages.item.itemTypeId.required': 'Vui lòng chọn loại sản phẩm',
  'pages.item.save': 'Lưu',
  'pages.item.inactive': 'Không hoạt động',
  'pages.supplier.code': 'Mã',
  'pages.supplier.name': 'Tên',
  'pages.supplier.updatedAt': 'Cập nhật lúc',
  'pages.supplier.createForm.title': 'Tạo nhà cung cấp mới',
  'pages.supplier.updateForm.title': 'Cập nhật nhà cung cấp',
  'pages.criteria.code': 'Mã',
  'pages.criteria.name': 'Tên',
  'pages.criteria.criteriaGroupId': 'Nhóm tiêu chí',
  'pages.criteria.isDefault': 'Mặc định',
  'pages.criteria.sortIndex': 'Thứ tự',
  'pages.criteria.isActive': 'Đang hoạt động',
  'pages.criteria.updatedAt': 'Cập nhật lúc',
  'pages.criteria.createForm.title': 'Tạo tiêu chí mới',
  'pages.criteria.updateForm.title': 'Cập nhật tiêu chí',
  'pages.delete.confirm': 'Bạn có chắc chắn muốn xóa mục này?',
  'pages.delete.ok': 'Xóa',
  'pages.delete.cancel': 'Hủy',
  'pages.qcStandard.code': 'Mã',
  'pages.qcStandard.product': 'Sản phẩm',
  'pages.qcStandard.item': 'Vật tư',
  'pages.qcStandard.material': 'Nguyên liệu',
  'pages.qcStandard.bomSpec': 'Thông số BOM',
  'pages.qcStandard.size': 'Kích thước',
  'pages.qcStandard.color': 'Màu sắc',
  'pages.qcStandard.date': 'Ngày',
  'pages.qcStandard.status': 'Trạng thái',
  'pages.qcStandard.status.draft': 'Nháp',
  'pages.qcStandard.status.pending': 'Chờ duyệt',
  'pages.qcStandard.status.approved': 'Đã duyệt',
  'pages.qcStandard.status.rejected': 'Từ chối',
  'pages.qcStandard.updatedAt': 'Cập nhật lúc',
  'pages.qcStandard.createForm.title': 'Tạo mới Bảng tiêu chuẩn',
  'pages.qcStandard.updateForm.title': 'Cập nhật Bảng tiêu chuẩn',
  'pages.qcStandard.details': 'Chi tiết Bảng tiêu chuẩn',
  'pages.qcStandard.create': 'Tạo mới',
  'pages.qcStandard.update': 'Cập nhật',
  'pages.qcStandard.cancel': 'Hủy',
  'pages.qcStandard.approve': 'Xác nhận',
  'pages.qcStandard.reject': 'Từ chối',
  'pages.qcStandard.delete': 'Xóa',
  'pages.qcStandard.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.qcStandard.delete.ok': 'Xóa',
  'pages.qcStandard.delete.cancel': 'Hủy',
  'pages.qcStandard.save': 'Lưu',
  'pages.qcStandardDetail.image': 'Hình ảnh',
  'pages.qcStandardDetail.criteria': 'Tiêu chí',
  'pages.qcStandardDetail.description': 'Diễn giải',
  'pages.qcStandardDetail.add': 'Thêm dòng',
  'pages.qcStandardDetail.remove': 'Xóa',
  'pages.productionOrder.code': 'Mã phiếu',
  'pages.productionOrder.date': 'Ngày phiếu',
  'pages.productionOrder.supplierName': 'Nhà cung cấp',
  'pages.productionOrder.status': 'Tình trạng',
  'pages.productionOrder.status.draft': 'Nháp',
  'pages.productionOrder.status.pending': 'Chờ duyệt',
  'pages.productionOrder.status.approved': 'Đã duyệt',
  'pages.productionOrder.status.rejected': 'Từ chối',
  'pages.productionOrder.updatedAt': 'Cập nhật lúc',
  'pages.productionOrder.createForm.title': 'Tạo mới phiếu sản xuất',
  'pages.productionOrder.updateForm.title': 'Cập nhật phiếu sản xuất',
  'pages.productionOrder.details': 'Chi tiết phiếu sản xuất',
  'pages.productionOrder.create': 'Tạo mới',
  'pages.productionOrder.update': 'Cập nhật',
  'pages.productionOrder.cancel': 'Hủy',
  'pages.productionOrder.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.productionOrder.delete.ok': 'Xóa',
  'pages.productionOrder.delete.cancel': 'Hủy',
  'pages.productionOrderProduct.image': 'Hình ảnh',
  'pages.productionOrderProduct.product': 'Sản phẩm',
  'pages.productionOrderProduct.uom': 'ĐVT',
  'pages.productionOrderProduct.quantity': 'Số lượng',
  'pages.productionOrderDetail.image': 'Hình ảnh',
  'pages.productionOrderDetail.itemName': 'Vật tư',
  'pages.productionOrderDetail.uom': 'ĐVT',
  'pages.productionOrderDetail.quantity': 'Số lượng',
  'pages.productionOrderDetail.unitPrice': 'Đơn giá',
  'pages.productionOrderDetail.amount': 'Thành tiền',
  'pages.productionOrderForApproval.approving': 'Đang duyệt...',
  'pages.productionOrderForApproval.approved.success': 'Duyệt thành công',
  'pages.productionOrderForApproval.approved.failed': 'Duyệt thất bại, vui lòng thử lại!',
  'pages.productionOrderForApproval.rejecting': 'Đang từ chối...',
  'pages.productionOrderForApproval.rejected.success': 'Từ chối thành công',
  'pages.productionOrderForApproval.rejected.failed': 'Từ chối thất bại, vui lòng thử lại!',
  'pages.productionOrderForApproval.expand': 'Mở rộng',
  'pages.productionOrderForApproval.collapse': 'Thu gọn',
  'pages.productionOrderForApproval.itemName': 'Mặt hàng',
  'pages.productionOrderForApproval.itemName.placeholder': 'Nhập tên mặt hàng',
  'pages.productionOrderForApproval.deliveryDate': 'Ngày giao',
  'pages.productionOrderForApproval.deliveryDate.placeholder': 'Chọn ngày giao',
  'pages.productionOrderForApproval.supplierName': 'Tên Nhà cung cấp',
  'pages.productionOrderForApproval.supplierName.placeholder': 'Nhập tên Nhà cung cấp',
  'pages.productionOrderForApproval.productionOrderCode': 'Lệnh sản xuất',
  'pages.productionOrderForApproval.productionOrderCode.placeholder': 'Nhập lệnh sản xuất',
  'pages.productionOrderForApproval.quantity': 'Số lượng',
  'pages.productionOrderForApproval.unitPrice': 'Đơn giá',
  'pages.productionOrderForApproval.amount': 'Thành tiền',
  'pages.productionOrderForApproval.deliveryDate.label': 'Ngày giao',
  'pages.productionOrderForApproval.description': 'Mô tả',
  'pages.productionOrderForApproval.loadedAll': 'Đã tải hết dữ liệu',
  'pages.productionOrderForApproval.approve': 'Duyệt',
  'pages.productionOrderForApproval.reject': 'Từ chối',
  'pages.productionOrderForSupplier.expand': 'Mở rộng',
  'pages.productionOrderForSupplier.collapse': 'Thu gọn',
  'pages.productionOrderForSupplier.itemName': 'Mặt hàng',
  // Plan module
  'pages.plan.code': 'Mã',
  'pages.plan.fromDate': 'Từ ngày',
  'pages.plan.toDate': 'Đến ngày',
  'pages.plan.organizationDetail': 'Tổ chức chi tiết',
  'pages.plan.description': 'Mô tả',
  'pages.plan.totalAmount': 'Tổng tiền',
  'pages.plan.updatedAt': 'Cập nhật lúc',
  'pages.plan.view.title': 'Xem Kế hoạch ngân sách',
  'pages.plan.create.title': 'Tạo Kế hoạch ngân sách',
  'pages.plan.update.title': 'Cập nhật Kế hoạch ngân sách',
  'pages.plan.code.placeholder': 'Nhập mã',
  'pages.plan.organizationDetail.placeholder': 'Chọn tổ chức chi tiết',
  'pages.plan.fromDate.placeholder': 'Chọn từ ngày',
  'pages.plan.toDate.placeholder': 'Chọn đến ngày',
  'pages.plan.description.placeholder': 'Nhập mô tả',
  'pages.plan.totalAmount.placeholder': 'Tổng tiền sẽ được tính tự động',
  'pages.plan.organizationDetail.search.placeholder': 'Chọn tổ chức chi tiết',
  'pages.plan.details': 'Chi tiết Kế hoạch ngân sách',
  'pages.plan.details.add': 'Thêm chi tiết',
  'pages.plan.details.delete': 'Xóa chi tiết',
  'pages.plan.detail.costItem': 'Khoản mục chi phí',
  'pages.plan.detail.costItem.placeholder': 'Chọn khoản mục chi phí',
  'pages.plan.detail.amount': 'Số tiền',
  'pages.plan.detail.amount.placeholder': 'Nhập số tiền',
  'pages.plan.detail.description': 'Mô tả',
  'pages.plan.detail.description.placeholder': 'Nhập mô tả',
  'pages.plan.status': 'Trạng thái',
  'pages.plan.status.draft': 'Nháp',
  'pages.plan.status.pending': 'Chờ duyệt',
  'pages.plan.status.approved': 'Đã duyệt',
  'pages.plan.status.rejected': 'Từ chối',
  'pages.plan.status.canceled': 'Đã hủy',
  'pages.plan.reason': 'Lý do',
  'pages.plan.createdAt': 'Tạo lúc',
  'pages.plan.approve': 'Xác nhận',
  'pages.plan.reject': 'Từ chối',
  'pages.plan.reject.reason': 'Lý do từ chối',
  'pages.plan.reject.confirm': 'Xác nhận',
  'pages.plan.reject.cancel': 'Hủy',
  'pages.plan.reject.reason.placeholder': 'Nhập lý do từ chối (bắt buộc)...',
  'pages.plan.cancel': 'Hủy',
  'pages.plan.cancel.reason': 'Lý do hủy',
  'pages.plan.cancel.confirm': 'Xác nhận',
  'pages.plan.cancel.cancel': 'Hủy',
  'pages.plan.cancel.reason.required': 'Vui lòng nhập lý do hủy',
  'pages.plan.cancel.reason.placeholder': 'Nhập lý do hủy (bắt buộc)...',
  'pages.plan.bulkReject.title': 'Từ chối hàng loạt kế hoạch',
  'pages.plan.bulkReject.description': 'Bạn có chắc chắn muốn từ chối hàng loạt các kế hoạch này?',
  'pages.plan.bulkReject.reason': 'Lý do từ chối hàng loạt:',
  'pages.plan.bulkReject.reasonPlaceholder': 'Nhập lý do từ chối hàng loạt',
  'pages.plan.bulkCancel.title': 'Hủy hàng loạt kế hoạch',
  'pages.plan.bulkCancel.description': 'Bạn có chắc chắn muốn hủy hàng loạt các kế hoạch này?',
  'pages.plan.bulkCancel.reason': 'Lý do hủy hàng loạt:',
  'pages.plan.bulkCancel.reasonPlaceholder': 'Nhập lý do hủy hàng loạt',
  'pages.plan.downloadTemplate': 'Tải mẫu',
  'pages.plan.import': 'Nhập dữ liệu',
  'pages.plan.actions': 'Thao tác',
  'pages.productionOrderForSupplier.itemName.placeholder': 'Nhập tên mặt hàng',
  'pages.productionOrderForSupplier.deliveryDate': 'Ngày giao',
  'pages.productionOrderForSupplier.deliveryDate.placeholder': 'Chọn ngày giao',
  'pages.productionOrderForSupplier.supplierName': 'Tên Nhà cung cấp',
  'pages.productionOrderForSupplier.supplierName.placeholder': 'Nhập tên Nhà cung cấp',
  'pages.productionOrderForSupplier.productionOrderCode': 'Lệnh sản xuất',
  'pages.productionOrderForSupplier.productionOrderCode.placeholder': 'Nhập lệnh sản xuất',
  'pages.productionOrderForSupplier.loadedAll': 'Đã tải hết dữ liệu',
  'pages.productionOrderOutput.code.label': 'Mã phiếu',
  'pages.productionOrderOutput.code.placeholder': 'Nhập mã phiếu',
  'pages.productionOrderOutput.code.required': 'Vui lòng nhập mã phiếu',
  'pages.productionOrderOutput.date.label': 'Ngày',
  'pages.productionOrderOutput.date.placeholder': 'Chọn ngày',
  'pages.productionOrderOutput.date.required': 'Vui lòng nhập ngày',
  'pages.productionOrderOutput.supplierId.label': 'Nhà cung cấp',
  'pages.productionOrderOutput.supplierId.placeholder': 'Chọn nhà cung cấp',
  'pages.productionOrderOutput.supplierId.required': 'Vui lòng chọn nhà cung cấp',
  'pages.productionOrderOutput.integrationId.label': 'Integration Id',
  'pages.productionOrderOutput.integrationId.placeholder': 'Nhập Integration Id',
  'pages.productionOrderOutput.integrationId.required': 'Integration Id là bắt buộc',
  'pages.productionOrderOutput.productId.label': 'Sản phẩm',
  'pages.productionOrderOutput.productId.required': 'Vui lòng chọn sản phẩm',
  'pages.productionOrderOutput.quantity.label': 'Sản lượng',
  'pages.productionOrderOutput.quantity.required': 'Vui lòng nhập sản lượng',
  'pages.productionOrderOutput.uom.label': 'ĐVT',
  'pages.productionOrderOutput.uom.required': 'Vui lòng nhập ĐVT',
  'pages.productionOrderOutput.notes.label': 'Ghi chú',
  'pages.productionOrderOutput.notes.placeholder': 'Nhập ghi chú',
  'pages.productionOrderOutput.isSync.label': 'Đồng bộ',
  'pages.productionOrderOutput.addProduct': 'Thêm sản phẩm',
  'pages.productionOrderOutput.remove': 'Xóa',
  'pages.productionOrderOutputQc.approving': 'Đang duyệt...',
  'pages.productionOrderOutputQc.approved.success': 'Duyệt thành công',
  'pages.productionOrderOutputQc.approved.failed': 'Duyệt thất bại, vui lòng thử lại!',
  'pages.productionOrderOutputQc.rejecting': 'Đang từ chối...',
  'pages.productionOrderOutputQc.rejected.success': 'Từ chối thành công',
  'pages.productionOrderOutputQc.rejected.failed': 'Từ chối thất bại, vui lòng thử lại!',
  'pages.productionOrderOutputQc.standard': 'Tiêu chuẩn',
  'pages.productionOrderOutputQc.actual': 'Thực tế',
  'pages.productionOrderOutputQc.notes.placeholder': 'Ghi chú',
  'pages.productionOrderOutputQc.submit.success': 'Gửi thành công',
  'pages.supplier.details': 'Chi tiết',
  'pages.supplier.delete.ok': 'Xóa',
  'pages.supplier.delete.cancel': 'Hủy',
  'pages.supplier.create': 'Tạo mới',
  'pages.supplier.update': 'Cập nhật',
  'pages.supplier.cancel': 'Hủy',
  'pages.supplier.code.required': 'Vui lòng nhập mã',
  'pages.supplier.name.required': 'Vui lòng nhập tên',
  'pages.supplier.save': 'Lưu',
  'pages.supplier.inactive': 'Không hoạt động',
  'pages.criteriaGroup.details': 'Chi tiết',
  'pages.criteriaGroup.delete.confirm': 'Bạn có chắc chắn muốn xóa?',
  'pages.criteriaGroup.delete.ok': 'Xóa',
  'pages.criteriaGroup.delete.cancel': 'Hủy',
  'pages.criteriaGroup.create': 'Tạo mới',
  'pages.criteriaGroup.update': 'Cập nhật',
  'pages.criteriaGroup.cancel': 'Hủy',
  'pages.criteriaGroup.code.required': 'Vui lòng nhập mã',
  'pages.criteriaGroup.name.required': 'Vui lòng nhập tên',
  'pages.criteriaGroup.save': 'Lưu',
  'pages.criteriaGroup.inactive': 'Không hoạt động',
  'pages.criteriaGroup.name': 'Tên',
  'pages.criteriaGroup.code': 'Mã',
  'pages.criteriaGroup.isActive': 'Trạng thái',
  'pages.criteriaGroup.updatedAt': 'Cập nhật lúc',
  'pages.itemType.details': 'Chi tiết',
  'pages.itemType.delete.confirm': 'Bạn có chắc chắn muốn xóa?',
  'pages.itemType.delete.ok': 'Xóa',
  'pages.itemType.delete.cancel': 'Hủy',
  'pages.itemType.create': 'Tạo mới',
  'pages.itemType.update': 'Cập nhật',
  'pages.itemType.cancel': 'Hủy',
  'pages.itemType.code.required': 'Vui lòng nhập mã',
  'pages.itemType.name.required': 'Vui lòng nhập tên',
  'pages.itemType.save': 'Lưu',
  'pages.itemType.inactive': 'Không hoạt động',
  'pages.productionOrderForApproval.sampleMark': 'Mẫu',
  'pages.productionOrderForApproval.card.quantity': 'Số lượng',
  'pages.productionOrderForApproval.card.unitPrice': 'Đơn giá',
  'pages.productionOrderForApproval.card.amount': 'Thành tiền',
  'pages.productionOrderForApproval.card.deliveryDate': 'Ngày giao',
  'pages.productionOrderForApproval.card.uom': 'ĐVT',
  'pages.productionOrderForApproval.card.vnd': 'VND',
  'pages.productionOrderForApproval.card.view': 'Xem',
  'pages.productionOrderForApproval.card.noImage': 'Không có hình',
  'pages.productionOrderForApproval.card.sample': 'Mẫu',
  'pages.productionOrderForApproval.card.loader': 'Đã tải hết dữ liệu',
  'pages.productionOrderForApproval.button.reject': 'Từ chối',
  'pages.productionOrderForApproval.button.approve': 'Xác nhận',
  'pages.productionOrderForSupplier.sampleMark': 'Mẫu',
  'pages.productionOrderForSupplier.card.done': 'Đã làm',
  'pages.productionOrderForSupplier.card.of': 'trên',
  'pages.productionOrderForSupplier.card.uom': 'ĐVT',
  'pages.productionOrderForSupplier.card.vnd': 'VND',
  'pages.productionOrderForSupplier.card.view': 'Xem',
  'pages.productionOrderForSupplier.card.noImage': 'Không có hình',
  'pages.productionOrderForSupplier.card.sample': 'Mẫu',
  'pages.productionOrderForSupplier.card.loader': 'Đã tải hết dữ liệu',
  'pages.productionOrderForSupplier.table.standard': 'Tiêu chuẩn',
  'pages.productionOrderForSupplier.table.actual': 'Thực tế',
  'pages.productionOrderForSupplier.table.notes': 'Ghi chú',
  'pages.productionOrderForSupplier.button.cancel': 'Hủy',
  'pages.productionOrderForSupplier.button.save': 'Lưu',
  'pages.productionOrderForSupplier.segmented.pass': 'Đạt',
  'pages.productionOrderForSupplier.segmented.fail': 'Không đạt',
  'pages.productionOrderForSupplier.message.submitted': 'Đã gửi',
  'pages.productionOrderOutputQc.table.standard': 'Tiêu chuẩn',
  'pages.productionOrderOutputQc.table.actual': 'Thực tế',
  'pages.productionOrderOutputQc.table.notes': 'Ghi chú',
  'pages.productionOrderOutputQc.button.cancel': 'Hủy',
  'pages.productionOrderOutputQc.button.save': 'Lưu',
  'pages.productionOrderOutputQc.button.approve': 'Duyệt',
  'pages.productionOrderOutputQc.button.reject': 'Từ chối',
  'pages.productionOrderOutputQc.button.reQc': 'Kiểm lại',
  'pages.productionOrderOutputQc.segmented.pass': 'Đạt',
  'pages.productionOrderOutputQc.segmented.fail': 'Không đạt',
  'pages.productionOrderOutputQc.switch.passed': 'Đạt',
  'pages.productionOrderOutputQc.switch.failed': 'Không đạt',
  'pages.productionOrderOutputQc.message.submitted': 'Đã gửi',
  'pages.productionOrderOutputQc.imageUrl': 'Hình ảnh',
  'pages.productionOrderOutputQc.outputCode': 'Mã phiếu SL',
  'pages.productionOrderOutputQc.code': 'Mã phiếu CL',
  'pages.productionOrderOutputQc.date': 'Ngày phiếu',
  'pages.productionOrderOutputQc.itemName': 'Vật tư',
  'pages.productionOrderOutputQc.outputQuantity': 'Sản lượng',
  'pages.productionOrderOutputQc.isPassed': 'Kết quả',
  'pages.productionOrderOutputQc.isReQc': 'Kiểm lại',
  'pages.productionOrderOutputQc.status': 'Tình trạng',
  'pages.productionOrderOutputQc.updatedAt': 'Cập nhật lúc',
  'pages.productionOrderOutputQc.status.draft': 'Nháp',
  'pages.productionOrderOutputQc.status.pending': 'Chờ duyệt',
  'pages.productionOrderOutputQc.status.approved': 'Đã duyệt',
  'pages.productionOrderOutputQc.status.rejected': 'Từ chối',
  'pages.productionOrderOutput.code': 'Mã phiếu',
  'pages.productionOrderOutput.date': 'Ngày phiếu',
  'pages.productionOrderOutput.supplierName': 'Nhà cung cấp',
  'pages.productionOrderOutput.status': 'Tình trạng',
  'pages.productionOrderOutput.status.draft': 'Nháp',
  'pages.productionOrderOutput.status.pending': 'Chờ duyệt',
  'pages.productionOrderOutput.status.approved': 'Đã duyệt',
  'pages.productionOrderOutput.status.rejected': 'Từ chối',
  'pages.productionOrderOutput.updatedAt': 'Cập nhật lúc',
  'pages.productionOrderOutput.createForm.title': 'Tạo mới phiếu sản xuất',
  'pages.productionOrderOutput.updateForm.title': 'Cập nhật phiếu sản xuất',
  'pages.productionOrderOutput.details': 'Chi tiết phiếu sản xuất',
  'pages.productionOrderOutput.create': 'Tạo mới',
  'pages.productionOrderOutput.update': 'Cập nhật',
  'pages.productionOrderOutput.cancel': 'Hủy',
  'pages.productionOrderOutput.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.productionOrderOutput.delete.ok': 'Xóa',
  'pages.productionOrderOutput.delete.cancel': 'Hủy',
  'pages.productionOrderOutput.save': 'Lưu',
  'pages.productionOrderOutput.inactive': 'Không hoạt động',
  'pages.productionOrderOutput.quantity': 'Sản lượng',
  'pages.productionOrderOutput.itemName': 'Vật tư',
  'pages.productionOrderOutput.productionOrderDetailUom': 'ĐVT',
  'pages.productionOrderOutput.productionOrderDetailQuantity': 'Số lượng',
  'pages.productionOrderOutput.productionOrderDetailUnitPrice': 'Đơn giá',
  'pages.productionOrderOutput.productionOrderDetailAmount': 'Thành tiền',
  'pages.productionOrderOutput.itemName.placeholder': 'Nhập tên vật tư',
  'pages.productionOrderOutput.notes': 'Ghi chú',
  'pages.productionOrderOutput.isSync': 'Đồng bộ',
  'pages.productionOrderOutputQc.qcStandardCode': 'Tiêu chuẩn',
  'pages.productionOrderOutputQcDetail.qcStandardDetailImageUrl': 'Tiêu chuẩn',
  'pages.productionOrderOutputQcDetail.imageUrl': 'Thực tế',
  'pages.productionOrderOutput.form.code': 'Mã phiếu',
  'pages.productionOrderOutput.form.code.placeholder': 'Nhập mã phiếu',
  'pages.productionOrderOutput.form.code.required': 'Vui lòng nhập mã phiếu',
  'pages.productionOrderOutput.form.date': 'Ngày',
  'pages.productionOrderOutput.form.date.placeholder': 'Chọn ngày',
  'pages.productionOrderOutput.form.date.required': 'Vui lòng nhập ngày',
  'pages.productionOrderOutput.form.supplier': 'Nhà cung cấp',
  'pages.productionOrderOutput.form.supplier.required': 'Vui lòng chọn nhà cung cấp',
  'pages.productionOrderOutput.form.integrationId': 'Integration Id',
  'pages.productionOrderOutput.form.integrationId.placeholder': 'Nhập Integration Id',
  'pages.productionOrderOutput.form.integrationId.required': 'Integration Id là bắt buộc',
  'pages.productionOrderOutput.form.productList.add': 'Thêm sản phẩm',
  'pages.productionOrderOutput.form.productList.remove': 'Xóa',
  'pages.productionOrderOutput.form.productList.label': 'Sản phẩm #{index}',
  'pages.productionOrderOutput.form.product': 'Sản phẩm',
  'pages.productionOrderOutput.form.product.required': 'Vui lòng chọn sản phẩm',
  'pages.productionOrderOutput.form.quantity': 'Số lượng',
  'pages.productionOrderOutput.form.quantity.placeholder': 'Nhập số lượng',
  'pages.productionOrderOutput.form.quantity.required': 'Vui lòng nhập số lượng',
  'pages.productionOrderOutput.form.uom': 'ĐVT',
  'pages.productionOrderOutput.form.uom.required': 'Vui lòng nhập ĐVT',
  'pages.qcStandard.reject.reason.required': 'Vui lòng nhập lý do từ chối',
  'pages.qcStandard.reject.confirm': 'Xác nhận',
  'pages.qcStandard.reject.cancel': 'Hủy',
  'pages.qcStandard.reject.reason': 'Lý do từ chối',
  'pages.qcStandard.reject.reason.placeholder': 'Nhập lý do từ chối (bắt buộc)...',
  'pages.productionOrderForApproval.reject.reason': 'Lý do từ chối',
  'pages.productionOrderForApproval.reject.reason.placeholder': 'Nhập lý do từ chối (bắt buộc)...',
  'pages.productionOrderForApproval.reject.confirm': 'Xác nhận',
  'pages.productionOrderForApproval.reject.cancel': 'Hủy',
  'pages.productionOrder.status.saved': 'Lưu sổ',
  'pages.productionOrder.status.canceled': 'Hủy',
  'pages.productionOrderOutput.productionOrderCode': 'Lệnh sản xuất',
  'pages.productionOrderForApproval.fromDeliveryDate.placeholder': 'Chọn từ ngày',
  'pages.productionOrderForApproval.toDeliveryDate.placeholder': 'Chọn đến ngày',
  'pages.productionOrderForSupplier.fromDeliveryDate.placeholder': 'Chọn từ ngày',
  'pages.productionOrderForSupplier.toDeliveryDate.placeholder': 'Chọn đến ngày',
  'pages.productionOrderForSupplier.qcDetails.incomplete': 'Không thể lưu. Chưa có Tiêu chuẩn cho sản phẩm này.',
  'pages.searchTable.print': 'In',
  'pages.organization.code': 'Mã',
  'pages.organization.name': 'Tên',
  'pages.organization.parent': 'Trực thuộc',
  'pages.organization.parent.search.placeholder': 'Chọn Trực thuộc',
  'pages.organization.level': 'Cấp độ',
  'pages.organization.updatedAt': 'Cập nhật lúc',
  'pages.organization.createdAt': 'Tạo lúc',
  'pages.organization.createForm.title': 'Tạo mới Tổ chức',
  'pages.organization.updateForm.title': 'Cập nhật Tổ chức',
  'pages.organization.details': 'Chi tiết Tổ chức',
  'pages.organization.update': 'Cập nhật',
  'pages.organization.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.organization.delete.ok': 'Xóa',
  'pages.organization.delete.cancel': 'Hủy',
  'pages.organization.save': 'Lưu',
  'pages.organization.cancel': 'Hủy',
  'pages.organization.parent.placeholder': 'Chọn Trực thuộc (chỉ hiển thị tổ chức có cấp độ thấp hơn)',
  'pages.organization.title': 'Tổ chức',
  'pages.organization.column.code': 'Mã',
  'pages.organization.column.name': 'Tên',
  'pages.organization.column.level': 'Cấp độ',
  'pages.organization.column.parent': 'Trực thuộc',
  'pages.organization.column.isActive': 'Trạng thái',
  'pages.organization.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.organization.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.organization.validation.levelRequired': 'Vui lòng nhập cấp độ',
  'pages.organization.validation.parentRequired': 'Trực thuộc là bắt buộc cho cấp độ > 1',
  'pages.organization.validation.tooltip': 'Sửa các trường bắt buộc (mã, tên, cấp độ, trực thuộc cho cấp độ>1)',
  'pages.organization.select.parent.placeholder': 'Chọn trực thuộc (cấp độ thấp hơn)',
  'pages.organization.active': 'Đang hoạt động',
  'pages.organization.inactive': 'Không hoạt động',
  'pages.organization.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.organization.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.organization.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.organization.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.organization.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.organization.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.organization.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.organization.message.fetchError': 'Không thể tải dữ liệu tổ chức',
  'pages.organization.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.organization.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.organization.refresh.tooltip': 'Làm mới sẽ hủy bỏ thay đổi chưa lưu',
  'pages.organization.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // Origin Detail
  'pages.origin.title': 'Chi tiết nguồn gốc',
  'pages.origin.column.code': 'Mã',
  'pages.origin.column.name': 'Tên',
  'pages.origin.column.isActive': 'Trạng thái',
  'pages.origin.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.origin.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.origin.active': 'Đang hoạt động',
  'pages.origin.inactive': 'Không hoạt động',
  'pages.origin.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.origin.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.origin.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.origin.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.origin.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.origin.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.origin.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.origin.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.origin.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.origin.message.fetchError': 'Không thể tải dữ liệu nguồn gốc',
  'pages.origin.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.origin.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.origin.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.origin.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.origin.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // Size Detail
  'pages.size.title': 'Chi tiết kích thước',
  'pages.size.column.code': 'Mã',
  'pages.size.column.name': 'Tên',
  'pages.size.column.description': 'Mô tả',
  'pages.size.column.isActive': 'Trạng thái',
  'pages.size.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.size.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.size.active': 'Đang hoạt động',
  'pages.size.inactive': 'Không hoạt động',
  'pages.size.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.size.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.size.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.size.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.size.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.size.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.size.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.size.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.size.message.fetchError': 'Không thể tải dữ liệu kích thước',
  'pages.size.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.size.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.size.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.size.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.size.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  // Job Position Detail
  'pages.jobPosition.title': 'Vị trí công việc',
  'pages.jobPosition.column.code': 'Mã',
  'pages.jobPosition.column.name': 'Tên',
  'pages.jobPosition.column.description': 'Mô tả',
  'pages.jobPosition.column.isActive': 'Trạng thái',
  'pages.jobPosition.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.jobPosition.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.jobPosition.active': 'Đang hoạt động',
  'pages.jobPosition.inactive': 'Không hoạt động',
  'pages.jobPosition.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.jobPosition.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.jobPosition.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.jobPosition.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.jobPosition.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.jobPosition.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.jobPosition.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.jobPosition.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.jobPosition.message.fetchError': 'Không thể tải dữ liệu vị trí công việc',
  'pages.jobPosition.message.apiNotAvailable': 'API chưa sẵn sàng. Thay đổi chưa được lưu.',
  'pages.jobPosition.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.jobPosition.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.jobPosition.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.jobPosition.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.jobPosition.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.jobPosition.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  // Light Source Detail
  'pages.lightSource.title': 'nguồn sáng',
  'pages.lightSource.column.code': 'Mã',
  'pages.lightSource.column.name': 'Tên',
  'pages.lightSource.column.description': 'Mô tả',
  'pages.lightSource.column.isActive': 'Trạng thái',
  'pages.lightSource.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.lightSource.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.lightSource.active': 'Đang hoạt động',
  'pages.lightSource.inactive': 'Không hoạt động',
  'pages.lightSource.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.lightSource.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.lightSource.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.lightSource.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.lightSource.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.lightSource.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.lightSource.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.lightSource.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.lightSource.message.fetchError': 'Không thể tải dữ liệu vị trí công việc',
  'pages.lightSource.message.apiNotAvailable': 'API chưa sẵn sàng. Thay đổi chưa được lưu.',
  'pages.lightSource.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.lightSource.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.lightSource.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.lightSource.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.lightSource.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.lightSource.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  // Section Detail
  'pages.section.title': 'Phần',
  'pages.section.column.code': 'Mã',
  'pages.section.column.name': 'Tên',
  'pages.section.column.description': 'Mô tả',
  'pages.section.column.isActive': 'Trạng thái',
  'pages.section.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.section.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.section.active': 'Đang hoạt động',
  'pages.section.inactive': 'Không hoạt động',
  'pages.section.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.section.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.section.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.section.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.section.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.section.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.section.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.section.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.section.message.fetchError': 'Không thể tải dữ liệu phần',
  'pages.section.message.apiNotAvailable': 'API chưa sẵn sàng. Thay đổi chưa được lưu.',
  'pages.section.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.section.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.section.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.section.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.section.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.section.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // UOM Detail
  'pages.uom.title': 'Chi tiết đơn vị tính',
  'pages.uom.column.code': 'Mã',
  'pages.uom.column.name': 'Tên',
  'pages.uom.column.decimalPlaces': 'Số lẻ thập phân',
  'pages.uom.column.orderDecimalPlaces': 'Số lẻ thập phân đơn hàng',
  'pages.uom.column.isActive': 'Trạng thái',
  'pages.uom.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.uom.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.uom.validation.decimalPlacesRequired': 'Vui lòng nhập số lẻ thập phân',
  'pages.uom.validation.orderDecimalPlacesRequired': 'Vui lòng nhập số lẻ thập phân đơn hàng',
  'pages.uom.active': 'Đang hoạt động',
  'pages.uom.inactive': 'Không hoạt động',
  'pages.uom.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.uom.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.uom.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.uom.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.uom.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.uom.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.uom.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.uom.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.uom.message.fetchError': 'Không thể tải dữ liệu đơn vị tính',
  'pages.uom.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.uom.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.uom.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  
  // Site Detail
  'pages.site.title': 'Chi tiết địa điểm',
  'pages.site.column.code': 'Mã',
  'pages.site.column.name': 'Tên',
  'pages.site.column.defaultLocation': 'Vị trí mặc định',
  'pages.site.column.isActive': 'Trạng thái',
  'pages.site.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.site.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.site.active': 'Đang hoạt động',
  'pages.site.inactive': 'Không hoạt động',
  'pages.site.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.site.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.site.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.site.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.site.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.site.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.site.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.site.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.site.message.fetchError': 'Không thể tải dữ liệu địa điểm',
  'pages.site.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.site.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.site.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.site.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.site.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // Line Detail
  'pages.line.title': 'Chi tiết dây chuyền',
  'pages.line.column.code': 'Mã',
  'pages.line.column.name': 'Tên',
  'pages.line.column.description': 'Mô tả',
  'pages.line.column.worker': 'Công nhân',
  'pages.line.column.isActive': 'Trạng thái',
  'pages.line.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.line.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.line.active': 'Đang hoạt động',
  'pages.line.inactive': 'Không hoạt động',
  'pages.line.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.line.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.line.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.line.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.line.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.line.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.line.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.line.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.line.message.fetchError': 'Không thể tải dữ liệu dây chuyền',
  'pages.line.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.line.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  
  // Machine Detail
  'pages.machine.title': 'Chi tiết máy móc',
  'pages.machine.column.code': 'Mã',
  'pages.machine.column.name': 'Tên',
  'pages.machine.column.description': 'Mô tả',
  'pages.machine.column.serialNo': 'Số seri',
  'pages.machine.column.capacity': 'Công suất',
  'pages.machine.column.capacityUOM': 'Đơn vị công suất',
  'pages.machine.column.machineDiameter': 'Đường kính máy',
  'pages.machine.column.gauge': 'Đồng hồ đo',
  'pages.machine.column.batchInDay': 'Lô trong ngày',
  'pages.machine.column.isActive': 'Trạng thái',
  'pages.machine.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.machine.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.machine.active': 'Đang hoạt động',
  'pages.machine.inactive': 'Không hoạt động',
  'pages.machine.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.machine.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.machine.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.machine.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.machine.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.machine.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.machine.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.machine.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.machine.message.fetchError': 'Không thể tải dữ liệu máy móc',
  'pages.machine.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.machine.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.machine.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.machine.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.machine.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // Supplier Detail
  'pages.supplier.title': 'Chi tiết nhà cung cấp',
  'pages.supplier.column.code': 'Mã',
  'pages.supplier.column.name': 'Tên',
  'pages.supplier.column.supplierTypeId': 'Loại nhà cung cấp',
  'pages.supplier.column.isActive': 'Trạng thái',
  'pages.supplier.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.supplier.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.supplier.active': 'Đang hoạt động',
  'pages.supplier.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.supplier.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.supplier.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.supplier.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.supplier.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.supplier.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.supplier.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.supplier.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.supplier.message.fetchError': 'Không thể tải dữ liệu nhà cung cấp',
  'pages.supplier.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.supplier.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.supplier.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.supplier.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.supplier.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // SupplierType Detail
  'pages.supplierType.title': 'Chi tiết loại nhà cung cấp',
  'pages.supplierType.column.code': 'Mã',
  'pages.supplierType.column.name': 'Tên',
  'pages.supplierType.column.isActive': 'Trạng thái',
  'pages.supplierType.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.supplierType.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.supplierType.active': 'Đang hoạt động',
  'pages.supplierType.inactive': 'Không hoạt động',
  'pages.supplierType.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.supplierType.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.supplierType.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.supplierType.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.supplierType.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.supplierType.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.supplierType.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.supplierType.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.supplierType.message.fetchError': 'Không thể tải dữ liệu loại nhà cung cấp',
  'pages.supplierType.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.supplierType.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.supplierType.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.supplierType.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.supplierType.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // Product Detail
  'pages.product.title': 'Chi tiết sản phẩm',
  'pages.product.column.code': 'Mã',
  'pages.product.column.name': 'Tên',
  'pages.product.column.subCategoryId': 'Danh mục con',
  'pages.product.column.storingUOMId': 'Đơn vị lưu trữ',
  'pages.product.column.saleUOMId': 'Đơn vị bán',
  'pages.product.column.purchaseUOMId': 'Đơn vị mua',
  'pages.product.column.consumptionUOMId': 'Đơn vị tiêu thụ',
  'pages.product.column.colorId': 'Màu sắc',
  'pages.product.column.sizeId': 'Kích thước',
  'pages.product.column.customerId': 'Khách hàng',
  'pages.product.column.supplierId': 'Nhà cung cấp',
  'pages.product.column.brandId': 'Thương hiệu',
  'pages.product.column.minimumQty': 'Số lượng tối thiểu',
  'pages.product.column.maximumQty': 'Số lượng tối đa',
  'pages.product.column.buyingPrice': 'Giá mua',
  'pages.product.column.buyingCurrencyId': 'Tiền tệ mua',
  'pages.product.column.description': 'Mô tả',
  'pages.product.column.fabricMaterial': 'Chất liệu vải',
  'pages.product.column.season': 'Mùa',
  'pages.product.column.buyerStyleRef': 'Mã kiểu người mua',
  'pages.product.column.sam': 'SAM',
  'pages.product.column.isActive': 'Trạng thái',
  'pages.product.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.product.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.product.validation.buyingCurrencyIdRequired': 'Vui lòng chọn tiền tệ mua',
  'pages.product.validation.storingUOMIdRequired': 'Vui lòng chọn đơn vị lưu trữ',
  'pages.product.active': 'Đang hoạt động',
  'pages.product.inactive': 'Không hoạt động',
  'pages.product.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.product.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.product.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.product.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.product.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.product.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.product.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.product.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.product.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.product.message.fetchError': 'Không thể tải dữ liệu sản phẩm',
  'pages.product.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.product.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.product.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.product.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.product.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.product.column.gsm': 'GSM',  
  
  // Holiday Detail
  'pages.holiday.title': 'Chi tiết ngày lễ',
  'pages.holiday.column.code': 'Mã',
  'pages.holiday.column.name': 'Tên',
  'pages.holiday.column.date': 'Ngày',
  'pages.holiday.column.isActive': 'Trạng thái',
  'pages.holiday.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.holiday.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.holiday.active': 'Đang hoạt động',
  'pages.holiday.inactive': 'Không hoạt động',
  'pages.holiday.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.holiday.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.holiday.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.holiday.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.holiday.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.holiday.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.holiday.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.holiday.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.holiday.message.fetchError': 'Không thể tải dữ liệu ngày lễ',
  'pages.holiday.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.holiday.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  
  // Port Detail
  'pages.port.title': 'Chi tiết cảng',
  'pages.port.column.code': 'Mã',
  'pages.port.column.name': 'Tên',
  'pages.port.column.countryId': 'Quốc gia',
  'pages.port.column.portOfLoading': 'Cảng xếp hàng',
  'pages.port.column.portOfDischarge': 'Cảng dỡ hàng',
  'pages.port.column.portOfReceiptByPreCarrier': 'Cảng nhận hàng bởi người vận chuyển trước',
  'pages.port.column.isActive': 'Trạng thái',
  'pages.port.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.port.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.port.active': 'Đang hoạt động',
  'pages.port.inactive': 'Không hoạt động',
  'pages.port.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.port.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.port.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.port.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.port.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.port.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.port.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.port.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.port.message.fetchError': 'Không thể tải dữ liệu cảng',
  'pages.port.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.port.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.port.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.port.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.port.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // ShipmentTerm Detail
  'pages.shipmentTerm.title': 'Chi tiết điều khoản vận chuyển',
  'pages.shipmentTerm.column.code': 'Mã',
  'pages.shipmentTerm.column.name': 'Tên',
  'pages.shipmentTerm.column.isActive': 'Trạng thái',
  'pages.shipmentTerm.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.shipmentTerm.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.shipmentTerm.active': 'Đang hoạt động',
  'pages.shipmentTerm.inactive': 'Không hoạt động',
  'pages.shipmentTerm.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.shipmentTerm.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.shipmentTerm.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.shipmentTerm.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.shipmentTerm.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.shipmentTerm.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.shipmentTerm.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.shipmentTerm.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.shipmentTerm.message.fetchError': 'Không thể tải dữ liệu điều khoản vận chuyển',
  'pages.shipmentTerm.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.shipmentTerm.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.shipmentTerm.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.shipmentTerm.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.shipmentTerm.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  // PaymentTerm Detail
  'pages.paymentTerm.title': 'Chi tiết điều khoản thanh toán',
  'pages.paymentTerm.column.code': 'Mã',
  'pages.paymentTerm.column.name': 'Tên',
  'pages.paymentTerm.column.creditDays': 'Số ngày tín dụng',
  'pages.paymentTerm.column.isActive': 'Trạng thái',
  'pages.paymentTerm.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.paymentTerm.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.paymentTerm.active': 'Đang hoạt động',
  'pages.paymentTerm.inactive': 'Không hoạt động',
  'pages.paymentTerm.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.paymentTerm.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.paymentTerm.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.paymentTerm.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.paymentTerm.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.paymentTerm.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.paymentTerm.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.paymentTerm.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.paymentTerm.message.fetchError': 'Không thể tải dữ liệu điều khoản thanh toán',
  'pages.paymentTerm.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.paymentTerm.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.paymentTerm.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.paymentTerm.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.paymentTerm.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  
  'pages.organizationDetail.title': 'Chi tiết tổ chức',
  'pages.organizationDetail.createForm.title': 'Thêm chi tiết tổ chức',
  'pages.organizationDetail.updateForm.title': 'Sửa chi tiết tổ chức',
  'pages.organizationDetail.form.name': 'Tên',
  'pages.organizationDetail.form.code': 'Mã',
  'pages.organizationDetail.form.integrationId': 'ID tích hợp',
  'pages.organizationDetail.form.organization': 'Tổ chức',
  'pages.organizationDetail.form.parentDetail': 'Trực thuộc',
  'pages.organizationDetail.form.name.required': 'Vui lòng nhập tên chi tiết tổ chức',
  'pages.organizationDetail.form.code.required': 'Vui lòng nhập mã chi tiết tổ chức',
  'pages.organizationDetail.form.organization.required': 'Vui lòng chọn tổ chức',
  'pages.organizationDetail.button.addNew': 'Thêm mới',
  'pages.organizationDetail.button.refresh': 'Làm mới',
  'pages.organizationDetail.button.save': 'Lưu',
  'pages.organizationDetail.button.cancel': 'Hủy',
  'pages.organizationDetail.message.createSuccess': 'Tạo chi tiết tổ chức thành công',
  'pages.organizationDetail.message.updateSuccess': 'Cập nhật chi tiết tổ chức thành công',
  'pages.organizationDetail.message.deleteSuccess': 'Xóa chi tiết tổ chức thành công',
  'pages.organizationDetail.message.createError': 'Không thể lưu chi tiết tổ chức',
  'pages.organizationDetail.message.deleteError': 'Không thể xóa chi tiết tổ chức',
  'pages.organizationDetail.message.fetchError': 'Không thể tải dữ liệu chi tiết tổ chức',
  'pages.organizationDetail.message.nestedDataError': 'Không thể tải dữ liệu lồng nhau',
  'pages.organizationDetail.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.organizationDetail.delete.yes': 'Có',
  'pages.organizationDetail.delete.no': 'Không',
  'pages.organizationDetail.button.edit': 'Sửa',
  'pages.organizationDetail.button.delete': 'Xóa',
  'pages.organizationDetail.placeholder.name': 'Nhập tên chi tiết tổ chức',
  'pages.organizationDetail.placeholder.code': 'Nhập mã chi tiết tổ chức',
  'pages.organizationDetail.placeholder.integrationId': 'Nhập ID tích hợp (tùy chọn)',
  'pages.organizationDetail.placeholder.organization': 'Chọn tổ chức',
  'pages.organizationDetail.placeholder.parentDetail': 'Chọn trực thuộc (tùy chọn)',
  'pages.organizationDetail.placeholder.organizationFirst': 'Chọn tổ chức trước',
  'pages.organizationDetail.column.code': 'Mã',
  'pages.organizationDetail.column.name': 'Tên',
  'pages.organizationDetail.column.organization': 'Tổ chức',
  'pages.organizationDetail.column.level': 'Cấp độ',
  'pages.organizationDetail.column.parent': 'Trực thuộc',
  'pages.organizationDetail.column.integrationId': 'ID tích hợp',
  'pages.organizationDetail.column.isActive': 'Đang hoạt động',
  'pages.organizationDetail.column.actions': 'Thao tác',
  'pages.organizationDetail.text.unknown': 'Không xác định',
  'pages.organizationDetail.code': 'Mã',
  'pages.organizationDetail.name': 'Tên',
  'pages.organizationDetail.parent': 'Trực thuộc',
  'pages.organizationDetail.employee': 'Nhân viên',
  'pages.organizationDetail.employee.placeholder': 'Chọn nhân viên',
  'pages.organizationDetail.add': 'Thêm chi tiết tổ chức',
  'pages.organizationDetail.remove': 'Xóa',
  'pages.organizationDetail.parent.placeholder': 'Chọn Trực thuộc cho chi tiết',
  'pages.organizationDetail.placeholder.selectOrganization': 'Chọn tổ chức',
  'pages.organizationDetail.validation.organizationRequired': 'Tổ chức là bắt buộc',
  'pages.organizationDetail.validation.codeRequired': 'Mã là bắt buộc',
  'pages.organizationDetail.validation.nameRequired': 'Tên là bắt buộc',
  'pages.organizationDetail.message.newNestedRecordRemoved': 'Đã xóa bản ghi lồng nhau mới thành công',
  'pages.organizationDetail.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.organizationDetail.message.failedToFetchOrganizationOptions': 'Không thể tải tùy chọn tổ chức',
  'pages.organizationDetail.message.organizationCreatedSuccessfully': 'Tạo tổ chức thành công',
  'pages.organizationDetail.message.failedToCreateOrganization': 'Không thể tạo tổ chức',
  'pages.organizationDetail.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.organizationDetail.message.missingRequiredFields': 'Thiếu các trường bắt buộc trong bảng chính: {errorDetails}',
  'pages.organizationDetail.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.organizationDetail.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.organizationDetail.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.organizationDetail.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.organizationDetail.message.newRowAddedSuccessfully': 'Đã thêm hàng mới thành công! Bắt đầu nhập để điền chi tiết.',
  'pages.organizationDetail.message.childRecordCreated': 'Đã tạo bản ghi con. Bạn có thể chỉnh sửa trong bảng lồng nhau bên dưới.',
  'pages.organizationDetail.tooltip.addChildRecord': 'Thêm bản ghi con',
  'pages.organizationDetail.tooltip.createChildOrganization': 'Tạo tổ chức con',
  'pages.organizationDetail.modal.createChildOrganization': 'Tạo Tổ chức Con',
  'pages.organizationDetail.modal.createNewOrganization': 'Tạo Tổ chức Mới',
  'pages.organizationDetail.form.organizationName': 'Tên Tổ chức',
  'pages.organizationDetail.form.organizationCode': 'Mã Tổ chức',
  'pages.organizationDetail.form.organizationLevel': 'Cấp độ Tổ chức',
  'pages.organizationDetail.form.parentOrganization': 'Tổ chức Trực thuộc',
  'pages.organizationDetail.form.organizationName.placeholder': 'Nhập tên tổ chức',
  'pages.organizationDetail.form.organizationCode.placeholder': 'Nhập mã tổ chức',
  'pages.organizationDetail.form.organizationLevel.placeholder': 'Chọn cấp độ tổ chức',
  'pages.organizationDetail.form.parentOrganization.placeholder': 'Chọn tổ chức trực thuộc',
  'pages.organizationDetail.form.organizationName.required': 'Vui lòng nhập tên tổ chức!',
  'pages.organizationDetail.form.organizationCode.required': 'Vui lòng nhập mã tổ chức!',
  'pages.organizationDetail.form.organizationLevel.required': 'Vui lòng chọn cấp độ tổ chức!',
  'pages.organizationDetail.form.organizationName.minMax': 'Tên phải từ 2 đến 50 ký tự.',
  'pages.organizationDetail.form.organizationCode.pattern': 'Mã chỉ có thể chứa chữ hoa và số.',
  'pages.organizationDetail.form.organizationCode.minMax': 'Mã phải từ 2 đến 10 ký tự.',
  'pages.organizationDetail.button.yes': 'Có',
  'pages.organizationDetail.button.no': 'Không',
  'pages.organizationDetail.button.create': 'Tạo',
  'pages.organizationDetail.dropdown.createNewOrganization': 'Tạo Tổ chức Mới',
  'pages.organizationDetail.validation.name.minMax': 'Tên phải từ 2 đến 50 ký tự.',
  'pages.organizationDetail.validation.code.pattern': 'Mã chỉ có thể chứa chữ hoa và số.',
  'pages.organizationDetail.validation.code.minMax': 'Mã phải từ 2 đến 10 ký tự.',
  'pages.organizationDetail.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.organizationDetail.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.organizationDetail.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.organizationDetail.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.organizationDetail.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.organization.chart.title': 'Biểu đồ Chi tiết Tổ chức',
  'pages.organization.chart.subtitle': 'Tổng quan Chi tiết Tổ chức',
  'pages.organization.chart.description': 'Tổng số bản ghi:',
  'pages.organization.chart.data.title': 'Cây Chi tiết Tổ chức',
  'pages.organization.chart.total': 'Tổng cộng',
  'pages.organization.chart.withParent': 'Có Trực thuộc',
  'pages.organization.chart.withoutParent': 'Không có Trực thuộc',
  'pages.organization.chart.showing': 'Hiển thị 10 bản ghi đầu tiên trong tổng số',
  'pages.organization.chart.noData': 'Không có dữ liệu chi tiết tổ chức',
  'pages.organization.chart.level': 'Cấp độ',
  'pages.costCategory.code': 'Mã',
  'pages.costCategory.name': 'Tên',
  'pages.costCategory.isActive': 'Trạng thái',
  'pages.costCategory.updatedAt': 'Cập nhật lúc',
  'pages.costCategory.createdAt': 'Tạo lúc',
  'pages.costCategory.create': 'Tạo mới',
  'pages.costCategory.update': 'Cập nhật',
  'pages.costCategory.details': 'Chi tiết Loại khoản mục',
  'pages.costCategory.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.costCategory.delete.ok': 'Xóa',
  'pages.costCategory.delete.cancel': 'Hủy',
  'pages.costCategory.save': 'Lưu',
  'pages.costCategory.cancel': 'Hủy',
  'pages.costCategory.close': 'Đóng',
  'pages.costCategory.code.required': 'Vui lòng nhập mã',
  'pages.costCategory.name.required': 'Vui lòng nhập tên',
  'pages.costItem.code': 'Mã',
  'pages.costItem.name': 'Tên',
  'pages.costItem.costCategory': 'Loại khoản mục',
  'pages.costItem.costCategory.search.placeholder': 'Chọn Loại khoản mục',
  'pages.costItem.isActive': 'Trạng thái',
  'pages.costItem.updatedAt': 'Cập nhật lúc',
  'pages.costItem.createdAt': 'Tạo lúc',
  'pages.costItem.create': 'Tạo mới',
  'pages.costItem.update': 'Cập nhật',
  'pages.costItem.details': 'Chi tiết Khoản mục chi phí',
  'pages.costItem.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.costItem.delete.ok': 'Xóa',
  'pages.costItem.delete.cancel': 'Hủy',
  'pages.costItem.save': 'Lưu',
  'pages.costItem.cancel': 'Hủy',
  'pages.costItem.close': 'Đóng',
  'pages.costItem.code.required': 'Vui lòng nhập mã',
  'pages.costItem.name.required': 'Vui lòng nhập tên',
  'pages.costItem.costCategoryId.required': 'Vui lòng chọn Loại khoản mục',
  'pages.employee.code': 'Mã',
  'pages.employee.name': 'Tên',
  'pages.employee.organizationDetail': 'Chi tiết tổ chức',
  'pages.employee.organizationDetail.search.placeholder': 'Chọn chi tiết tổ chức',
  'pages.employee.isActive': 'Trạng thái',
  'pages.employee.updatedAt': 'Cập nhật lúc',
  'pages.employee.createdAt': 'Tạo lúc',
  'pages.employee.create': 'Tạo mới',
  'pages.employee.update': 'Cập nhật',
  'pages.employee.details': 'Chi tiết Nhân viên',
  'pages.employee.delete.confirm': 'Bạn có chắc muốn xóa?',
  'pages.employee.delete.ok': 'Xóa',
  'pages.employee.delete.cancel': 'Hủy',
  'pages.employee.save': 'Lưu',
  'pages.employee.cancel': 'Hủy',
  'pages.employee.close': 'Đóng',
  'pages.employee.code.required': 'Vui lòng nhập mã',
  'pages.employee.name.required': 'Vui lòng nhập tên',
  'pages.employee.title': 'Chi tiết nhân viên',
  'pages.employee.column.code': 'Mã',
  'pages.employee.column.name': 'Tên',
  'pages.employee.column.isActive': 'Trạng thái',
  'pages.employee.column.organization': 'Tổ chức',
  'pages.employee.column.jobPosition': 'Vị trí công việc',
  'pages.employee.column.manager': 'Quản lý',
  'pages.employee.column.personInChargeType': 'Người phụ trách',
  'pages.employee.personInCharge.incharge': 'Incharge',
  'pages.employee.personInCharge.all': 'All',
  'pages.employee.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.employee.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.employee.message.fetchError': 'Không thể tải dữ liệu nhân viên',
  'pages.employee.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.employee.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.employee.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.employee.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.employee.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.employee.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.employee.active': 'Đang hoạt động',
  'pages.employee.inactive': 'Không hoạt động',
  'pages.employee.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.employee.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.employee.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.employee.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.employee.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.employee.delete.confirm2': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.costRequest.code': 'Mã',
  'pages.costRequest.type': 'Loại',
  'pages.costRequest.type.manual': 'Thủ công',
  'pages.costRequest.type.synced': 'Đồng bộ',
  'pages.costRequest.date': 'Ngày',
  'pages.costRequest.costCategory': 'Loại khoản mục',
  'pages.costRequest.costItem': 'Khoản mục chi phí',
  'pages.costRequest.organizationDetail': 'Bộ phận yêu cầu',
  'pages.costRequest.description': 'Mô tả',
  'pages.costRequest.reason': 'Lý do',
  'pages.costRequest.totalAmount': 'Tổng tiền',
  'pages.costRequest.status': 'Trạng thái',
  'pages.costRequest.status.draft': 'Nháp',
  'pages.costRequest.status.pending': 'Chờ duyệt',
  'pages.costRequest.status.approved': 'Đã duyệt',
  'pages.costRequest.status.rejected': 'Từ chối',
  'pages.costRequest.status.canceled': 'Đã hủy',
  'pages.costRequest.updatedAt': 'Cập nhật lúc',
  'pages.costRequest.createdAt': 'Tạo lúc',
  'pages.costRequest.view.title': 'Xem Yêu cầu chi phí',
  'pages.costRequest.create.title': 'Tạo mới Yêu cầu chi phí',
  'pages.costRequest.update.title': 'Cập nhật Yêu cầu chi phí',
  'pages.costRequest.approve': 'Xác nhận',
  'pages.costRequest.reject': 'Từ chối',
  'pages.costRequest.reject.reason': 'Lý do từ chối',
  'pages.costRequest.reject.confirm': 'Xác nhận',
  'pages.costRequest.reject.cancel': 'Hủy',
  'pages.costRequest.reject.reason.placeholder': 'Nhập lý do từ chối (bắt buộc)...',
  'pages.costRequest.cancel': 'Hủy',
  'pages.costRequest.cancel.reason': 'Lý do hủy',
  'pages.costRequest.cancel.confirm': 'Xác nhận',
  'pages.costRequest.cancel.cancel': 'Hủy',
  'pages.costRequest.cancel.reason.required': 'Vui lòng nhập lý do hủy',
  'pages.costRequest.cancel.reason.placeholder': 'Nhập lý do hủy (bắt buộc)...',
  'pages.costRequest.bulkReject.title': 'Từ chối hàng loạt yêu cầu chi phí',
  'pages.costRequest.bulkReject.description': 'Bạn có chắc chắn muốn từ chối hàng loạt các yêu cầu chi phí này?',
  'pages.costRequest.bulkReject.reason': 'Lý do từ chối hàng loạt:',
  'pages.costRequest.bulkReject.reasonPlaceholder': 'Nhập lý do từ chối hàng loạt',
  'pages.costRequest.bulkCancel.title': 'Hủy hàng loạt yêu cầu chi phí',
  'pages.costRequest.bulkCancel.description': 'Bạn có chắc chắn muốn hủy hàng loạt các yêu cầu chi phí này?',
  'pages.costRequest.bulkCancel.reason': 'Lý do hủy hàng loạt:',
  'pages.costRequest.bulkCancel.reasonPlaceholder': 'Nhập lý do hủy hàng loạt',
  'pages.costRequest.code.placeholder': 'Nhập mã',
  'pages.costRequest.type.placeholder': 'Chọn loại',
  'pages.costRequest.date.placeholder': 'Chọn ngày',
  'pages.costRequest.costItem.placeholder': 'Chọn khoản mục chi phí',
  'pages.costRequest.organizationDetail.placeholder': 'Chọn bộ phận yêu cầu',
  'pages.costRequest.costItem.search.placeholder': 'Chọn khoản mục chi phí',
  'pages.costRequest.organizationDetail.search.placeholder': 'Chọn bộ phận yêu cầu',
  'pages.costRequest.description.placeholder': 'Nhập mô tả',
  'pages.costRequest.totalAmount.placeholder': 'Tổng tiền sẽ được tính tự động',
  'pages.costRequest.details.add': 'Thêm chi tiết',
  'pages.costRequest.details.delete': 'Xóa chi tiết',
  'pages.costRequest.detail.organizationDetail': 'Tổ chức chi tiết',
  'pages.costRequest.detail.organizationDetail.placeholder': 'Chọn tổ chức chi tiết',
  'pages.costRequest.detail.amount': 'Số tiền',
  'pages.costRequest.detail.amount.placeholder': 'Nhập số tiền',
  'pages.costRequest.detail.description': 'Mô tả',
  'pages.costRequest.detail.description.placeholder': 'Nhập mô tả',
  'pages.reports.title': 'Báo cáo',
  'pages.reports.organization': 'Ngân sách theo tổ chức',
  'pages.reports.organizationDetail': 'Tổ chức',
  'pages.reports.organizationDetail.placeholder': 'Chọn tổ chức',
  'pages.reports.period': 'Kỳ báo cáo',
  'pages.reports.period.yearly': 'Năm',
  'pages.reports.period.quarterly': 'Quý',
  'pages.reports.period.monthly': 'Tháng',
  'pages.reports.year': 'Năm',
  'pages.reports.year.placeholder': 'Chọn năm',
  'pages.reports.quarter': 'Quý',
  'pages.reports.quarter.placeholder': 'Chọn quý',
  'pages.reports.month': 'Tháng',
  'pages.reports.month.placeholder': 'Chọn tháng',
  'pages.reports.search': 'Tìm kiếm',
  'pages.reports.totalPlanAmount': 'Kế hoạch',
  'pages.reports.totalApprovedAmount': 'Đã duyệt',
  'pages.reports.totalPendingAmount': 'Chờ duyệt',
  'pages.reports.totalBalanceAmount': 'Còn lại',
  'pages.reports.consumedPercentage': 'Tỷ lệ Sử dụng',
  'pages.reports.totalRequest': 'Số lượng Yêu cầu',
  'pages.reports.details': 'Chi tiết',

  'pages.reports.costItem': 'Ngân sách theo khoản mục chi phí',
  'pages.reports.planAmount': 'Kế hoạch',
  'pages.reports.approvedAmount': 'Đã duyệt',
  'pages.reports.pendingAmount': 'Chờ duyệt',
  'pages.reports.balanceAmount': 'Còn lại',
  'pages.reports.table': 'Bảng',
  'pages.reports.charts': 'Biểu đồ',
  'pages.reports.matrix': 'Ma trận',
  'pages.reports.noData': 'Không có dữ liệu. Vui lòng chọn bộ lọc và tìm kiếm để xem kết quả.',
  'pages.reports.chart.column': 'Biểu đồ cột',
  'pages.reports.chart.column.title': 'Kế hoạch theo khoản mục chi phí',
  'pages.reports.chart.pie': 'Biểu đồ tròn',
  'pages.reports.chart.pie.title': 'Phân bố kế hoạch theo loại',
  'pages.reports.chart.line': 'Biểu đồ đường',
  'pages.reports.chart.line.title': 'Xu hướng kế hoạch',
  'pages.reports.chart.dual': 'Biểu đồ kép',
  'pages.reports.chart.dual.title': 'So sánh Kế hoạch vs Đã duyệt',
  'pages.reports.chart.byPeriod': 'Theo Kỳ',
  'pages.reports.chart.byOrganization': 'Theo Tổ chức',
  'pages.reports.matrix.organizationView': 'Xem theo Tổ chức',
  'pages.reports.matrix.costView': 'Xem theo Chi phí',
  'pages.reports.chart.type.planAmount': 'Kế hoạch',
  'pages.reports.chart.type.approvedAmount': 'Đã duyệt',
  'pages.reports.chart.type.pendingAmount': 'Chờ duyệt',
  'pages.reports.chart.type.approvedAmountNotPlan': 'Đã duyệt (Không có kế hoạch)',
  'pages.reports.chart.type.pendingAmountNotPlan': 'Chờ duyệt (Không có kế hoạch)',
  'pages.reports.costCategory.placeholder': 'Chọn loại khoản mục',
  'pages.reports.costItem.placeholder': 'Chọn khoản mục chi phí',

  'pages.reports.organizationDetailParent': 'Trực thuộc',
  'pages.reports.summary': 'Báo cáo Tổng hợp',
  'pages.reports.type': 'Loại',
  'pages.reports.type.placeholder': 'Chọn loại',
  'pages.reports.type.all': 'Tất cả loại',
  'pages.reports.type.expense': 'Chi phí',
  'pages.reports.type.income': 'Thu nhập',
  'pages.reports.organizationLevel': 'Cấp độ Tổ chức',
  'pages.reports.organizationLevel.placeholder': 'Chọn cấp độ tổ chức',
  'pages.reports.organizationLevel.all': 'Tất cả cấp độ',
  'pages.reports.organizationLevel.level1': 'Cấp 1',
  'pages.reports.organizationLevel.level2': 'Cấp 2',
  'pages.reports.organizationLevel.level3': 'Cấp 3',
  'pages.reports.viewMode': 'Chế độ xem',
  'pages.reports.viewMode.yearly': 'Năm',
  'pages.reports.viewMode.quarterly': 'Quý',
  'pages.reports.viewMode.monthly': 'Tháng',
  'pages.reports.dateRange': 'Khoảng thời gian',
  'pages.reports.dateRange.start': 'Từ ngày',
  'pages.reports.dateRange.end': 'Đến ngày',
  'pages.reports.expand': 'Mở rộng',
  'pages.reports.collapse': 'Thu gọn',
  'pages.reports.expandAll': 'Mở rộng tất cả',
  'pages.reports.collapseAll': 'Thu gọn tất cả',
  'pages.reports.export': 'Xuất',
  'pages.reports.exportToExcel': 'Xuất Excel',

  // Address Detail
  'pages.addressDetail.title': 'Chi tiết địa chỉ',
  'pages.addressDetail.filter.address': 'Địa chỉ',
  'pages.addressDetail.placeholder.selectAddress': 'Chọn địa chỉ',
  'pages.addressDetail.column.address': 'Địa chỉ',
  'pages.addressDetail.column.code': 'Mã',
  'pages.addressDetail.column.name': 'Tên',
  'pages.addressDetail.column.integrationId': 'ID tích hợp',
  'pages.addressDetail.column.zipCode': 'Mã bưu chính',
  'pages.addressDetail.column.longitude': 'Kinh độ',
  'pages.addressDetail.column.latitude': 'Vĩ độ',
  'pages.addressDetail.validation.addressRequired': 'Vui lòng chọn địa chỉ',
  'pages.addressDetail.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.addressDetail.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.addressDetail.message.fetchError': 'Không thể tải dữ liệu chi tiết địa chỉ',
  'pages.addressDetail.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.addressDetail.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.addressDetail.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.addressDetail.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.addressDetail.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  // Operation Library Detail
  'pages.operationLibraryDetail.title': 'Chi tiết thư viện công đoạn',
  'pages.operationLibraryDetail.filter.operationLibrary': 'Thư viện công đoạn',
  'pages.operationLibraryDetail.placeholder.selectOperationLibrary': 'Chọn thư viện công đoạn',
  'pages.operationLibraryDetail.column.operationLibrary': 'Thư viện công đoạn',
  'pages.operationLibraryDetail.column.code': 'Mã',
  'pages.operationLibraryDetail.column.name': 'Tên',
  'pages.operationLibraryDetail.column.subCategories': 'Sub Category',
  'pages.operationLibraryDetail.column.machineType': 'Loại máy',
  'pages.operationLibraryDetail.column.integrationId': 'ID tích hợp',
  'pages.operationLibraryDetail.validation.operationLibraryRequired': 'Vui lòng chọn thư viện công đoạn',
  'pages.operationLibraryDetail.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.operationLibraryDetail.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.operationLibraryDetail.message.fetchError': 'Không thể tải dữ liệu chi tiết thư viện công đoạn',
  'pages.operationLibraryDetail.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.operationLibraryDetail.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.operationLibraryDetail.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.operationLibraryDetail.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.operationLibraryDetail.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',


  // Account Group Detail
  'pages.accountGroup.title': 'Chi tiết nhóm tài khoản',
  'pages.accountGroup.column.code': 'Mã',
  'pages.accountGroup.column.name': 'Tên',
  'pages.accountGroup.column.isActive': 'Trạng thái',
  'pages.accountGroup.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.accountGroup.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.accountGroup.message.fetchError': 'Không thể tải dữ liệu nhóm tài khoản',
  'pages.accountGroup.active': 'Đang hoạt động',
  'pages.accountGroup.inactive': 'Không hoạt động',
  'pages.accountGroup.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.accountGroup.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.accountGroup.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.accountGroup.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.accountGroup.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.accountGroup.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.common.noPermission': 'Bạn không có quyền thực hiện thao tác này',

  // Brand Detail
  'pages.brand.title': 'Chi tiết thương hiệu',
  'pages.brand.column.code': 'Mã',
  'pages.brand.column.name': 'Tên',
  'pages.brand.column.isActive': 'Trạng thái',
  'pages.brand.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.brand.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.brand.message.fetchError': 'Không thể tải dữ liệu thương hiệu',
  'pages.brand.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.brand.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.brand.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.brand.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.brand.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.brand.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.brand.active': 'Đang hoạt động',
  'pages.brand.inactive': 'Không hoạt động',
  'pages.brand.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.brand.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.brand.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.brand.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.brand.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.brand.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Color Detail
  'pages.color.title': 'Chi tiết màu sắc',
  'pages.color.column.code': 'Mã',
  'pages.color.column.name': 'Tên',
  'pages.color.column.type': 'Loại',
  'pages.color.column.value': 'Giá trị',
  'pages.color.column.description': 'Mô tả',
  'pages.color.column.isActive': 'Trạng thái',
  'pages.color.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.color.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.color.validation.typeRequired': 'Vui lòng nhập loại',
  'pages.color.validation.valueRequired': 'Vui lòng nhập giá trị',
  'pages.color.message.fetchError': 'Không thể tải dữ liệu màu sắc',
  'pages.color.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.color.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.color.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.color.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.color.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.color.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.color.active': 'Đang hoạt động',
  'pages.color.inactive': 'Không hoạt động',
  'pages.color.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.color.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.color.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.color.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.color.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.color.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Currency Detail
  'pages.currency.title': 'Chi tiết tiền tệ',
  'pages.currency.column.code': 'Mã',
  'pages.currency.column.name': 'Tên',
  'pages.currency.column.decimalPlaces': 'Số lẻ thập phân',
  'pages.currency.column.isActive': 'Trạng thái',
  'pages.currency.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.currency.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.currency.message.fetchError': 'Không thể tải dữ liệu tiền tệ',
  'pages.currency.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.currency.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.currency.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.currency.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.currency.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.currency.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.currency.active': 'Đang hoạt động',
  'pages.currency.inactive': 'Không hoạt động',
  'pages.currency.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.currency.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.currency.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.currency.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.currency.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.currency.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Customer Detail
  'pages.customer.title': 'Chi tiết khách hàng',
  'pages.customer.column.code': 'Mã',
  'pages.customer.column.name': 'Tên',
  'pages.customer.column.isActive': 'Trạng thái',
  'pages.customer.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.customer.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.customer.message.fetchError': 'Không thể tải dữ liệu khách hàng',
  'pages.customer.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.customer.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.customer.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.customer.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.customer.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.customer.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.customer.active': 'Đang hoạt động',
  'pages.customer.inactive': 'Không hoạt động',
  'pages.customer.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.customer.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.customer.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.customer.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.customer.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.customer.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Customer Type Detail
  'pages.customerType.title': 'Chi tiết loại khách hàng',
  'pages.customerType.column.code': 'Mã',
  'pages.customerType.column.name': 'Tên',
  'pages.customerType.column.isActive': 'Trạng thái',
  'pages.customerType.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.customerType.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.customerType.message.fetchError': 'Không thể tải dữ liệu loại khách hàng',
  'pages.customerType.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.customerType.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.customerType.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.customerType.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.customerType.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.customerType.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.customerType.active': 'Đang hoạt động',
  'pages.customerType.inactive': 'Không hoạt động',
  'pages.customerType.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.customerType.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.customerType.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.customerType.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.customerType.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.customerType.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Address Detail
  'pages.address.title': 'Chi tiết địa chỉ',
  'pages.address.column.code': 'Mã',
  'pages.address.column.name': 'Tên',
  'pages.address.column.isActive': 'Trạng thái',
  'pages.address.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.address.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.address.message.fetchError': 'Không thể tải dữ liệu địa chỉ',
  'pages.address.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.address.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.address.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.address.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.address.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.address.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.address.active': 'Đang hoạt động',
  'pages.address.inactive': 'Không hoạt động',
  'pages.address.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.address.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.address.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.address.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.address.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.address.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Calendar Customize Detail
  'pages.calendarCustomize.title': 'Chi tiết lịch tùy chỉnh',
  'pages.calendarCustomize.column.code': 'Mã',
  'pages.calendarCustomize.column.name': 'Tên',
  'pages.calendarCustomize.column.fromDate': 'Từ ngày',
  'pages.calendarCustomize.column.toDate': 'Đến ngày',
  'pages.calendarCustomize.column.isActive': 'Trạng thái',
  'pages.calendarCustomize.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.calendarCustomize.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.calendarCustomize.validation.fromDateRequired': 'Vui lòng nhập Từ ngày',
  'pages.calendarCustomize.validation.toDateRequired': 'Vui lòng nhập Đến ngày',
  'pages.calendarCustomize.message.fetchError': 'Không thể tải dữ liệu lịch tùy chỉnh',
  'pages.calendarCustomize.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.calendarCustomize.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.calendarCustomize.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.calendarCustomize.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.calendarCustomize.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.calendarCustomize.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.calendarCustomize.active': 'Đang hoạt động',
  'pages.calendarCustomize.inactive': 'Không hoạt động',
  'pages.calendarCustomize.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.calendarCustomize.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.calendarCustomize.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.calendarCustomize.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.calendarCustomize.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.calendarCustomize.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Calendar Detail
  'pages.calendar.title': 'Chi tiết lịch',
  'pages.calendar.column.code': 'Mã',
  'pages.calendar.column.name': 'Tên',
  'pages.calendar.column.isActive': 'Trạng thái',
  'pages.calendar.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.calendar.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.calendar.message.fetchError': 'Không thể tải dữ liệu lịch',
  'pages.calendar.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.calendar.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.calendar.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.calendar.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.calendar.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.calendar.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.calendar.active': 'Đang hoạt động',
  'pages.calendar.inactive': 'Không hoạt động',
  'pages.calendar.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.calendar.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.calendar.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.calendar.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.calendar.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.calendar.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  
  // Delivery Term Detail
  'pages.deliveryTerm.title': 'Chi tiết điều khoản giao hàng',
  'pages.deliveryTerm.column.code': 'Mã',
  'pages.deliveryTerm.column.name': 'Tên',
  'pages.deliveryTerm.column.isActive': 'Trạng thái',
  'pages.deliveryTerm.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.deliveryTerm.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.deliveryTerm.message.fetchError': 'Không thể tải dữ liệu điều khoản giao hàng',
  'pages.deliveryTerm.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.deliveryTerm.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.deliveryTerm.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.deliveryTerm.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.deliveryTerm.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.deliveryTerm.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.deliveryTerm.active': 'Đang hoạt động',
  'pages.deliveryTerm.inactive': 'Không hoạt động',
  'pages.deliveryTerm.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.deliveryTerm.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.deliveryTerm.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.deliveryTerm.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.deliveryTerm.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.deliveryTerm.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // QueryFilter Labels
  'pages.queryFilter.label.code': 'Mã',
  'pages.queryFilter.label.name': 'Tên',
  'pages.queryFilter.label.integrationId': 'ID tích hợp',
  'pages.queryFilter.label.zipCode': 'Mã bưu điện',
  'pages.queryFilter.label.isActive': 'Trạng thái',
  'pages.queryFilter.label.organization': 'Tổ chức',
  
  // Category Detail
  'pages.category.title': 'Chi tiết danh mục',
  'pages.category.column.code': 'Mã',
  'pages.category.column.name': 'Tên',
  'pages.category.column.isActive': 'Trạng thái',
  'pages.category.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.category.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.category.message.fetchError': 'Không thể tải dữ liệu danh mục',
  'pages.category.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.category.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.category.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.category.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.category.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.category.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.category.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.category.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.category.active': 'Đang hoạt động',
  'pages.category.inactive': 'Không hoạt động',
  'pages.category.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.category.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.category.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.category.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.category.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.category.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // ProductCategory Detail
  'pages.productCategory.title': 'Chi tiết danh mục sản phẩm',
  'pages.productCategory.column.code': 'Mã',
  'pages.productCategory.column.name': 'Tên',
  'pages.productCategory.column.isActive': 'Trạng thái',
  'pages.productCategory.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.productCategory.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.productCategory.validation.parentRequired': 'Cấp cha là bắt buộc khi cấp > 1',
  'pages.productCategory.message.fetchError': 'Không thể tải dữ liệu danh mục sản phẩm',
  'pages.productCategory.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.productCategory.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.productCategory.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.productCategory.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.productCategory.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.productCategory.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.productCategory.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.productCategory.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.productCategory.active': 'Đang hoạt động',
  'pages.productCategory.inactive': 'Không hoạt động',
  'pages.productCategory.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.productCategory.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.productCategory.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.productCategory.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.productCategory.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.productCategory.column.integrationIds': 'ID tích hợp',
  'pages.productCategory.delete.confirm': 'Bạn có chắc chắn muốn xóa danh mục này?',
  'pages.productCategory.delete.description':
    'Không thể xóa nếu danh mục đã được gán vào sản phẩm, BOM hoặc routing.',

  // ProductGroup Detail
  'pages.productGroup.title': 'Chi tiết nhóm sản phẩm',
  'pages.productGroup.column.code': 'Mã',
  'pages.productGroup.column.name': 'Tên',
  'pages.productGroup.column.isActive': 'Trạng thái',
  'pages.productGroup.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.productGroup.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.productGroup.message.fetchError': 'Không thể tải dữ liệu nhóm sản phẩm',
  'pages.productGroup.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.productGroup.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.productGroup.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.productGroup.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.productGroup.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.productGroup.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.productGroup.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.productGroup.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.productGroup.active': 'Đang hoạt động',
  'pages.productGroup.inactive': 'Không hoạt động',
  'pages.productGroup.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.productGroup.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.productGroup.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.productGroup.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.productGroup.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.productGroup.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // SubCategory Detail
  'pages.subCategory.title': 'Chi tiết danh mục con',
  'pages.subCategory.column.code': 'Mã',
  'pages.subCategory.column.name': 'Tên',
  'pages.subCategory.column.isActive': 'Trạng thái',
  'pages.subCategory.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.subCategory.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.subCategory.message.fetchError': 'Không thể tải dữ liệu danh mục con',
  'pages.subCategory.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.subCategory.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.subCategory.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.subCategory.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.subCategory.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.subCategory.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.subCategory.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.subCategory.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.subCategory.active': 'Đang hoạt động',
  'pages.subCategory.inactive': 'Không hoạt động',
  'pages.subCategory.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.subCategory.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.subCategory.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.subCategory.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.subCategory.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',
  'pages.subCategory.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',

  // Component Detail
  'pages.component.title': 'Chi tiết thành phần',
  'pages.component.column.code': 'Mã',
  'pages.component.column.name': 'Tên',
  'pages.component.column.componentGroupId': 'Nhóm thành phần',
  'pages.component.column.componentGroupName': 'Tên nhóm thành phần',
  'pages.component.column.uomId': 'Đơn vị tính',
  'pages.component.column.consumptionQuantity': 'Số lượng tiêu thụ',
  'pages.component.column.isActive': 'Trạng thái',
  'pages.component.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.component.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.component.active': 'Đang hoạt động',
  'pages.component.inactive': 'Không hoạt động',
  'pages.component.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.component.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.component.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.component.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.component.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.component.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.component.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.component.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.component.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.component.message.fetchError': 'Không thể tải dữ liệu thành phần',
  'pages.component.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.component.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.component.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.component.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.component.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  // ComponentGroup Detail
  'pages.componentGroup.title': 'Chi tiết nhóm thành phần',
  'pages.componentGroup.column.code': 'Mã',
  'pages.componentGroup.column.name': 'Tên',
  'pages.componentGroup.column.productId': 'Sản phẩm',
  'pages.componentGroup.column.productName': 'Tên sản phẩm',
  'pages.componentGroup.column.isActive': 'Trạng thái',
  'pages.componentGroup.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.componentGroup.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.componentGroup.active': 'Đang hoạt động',
  'pages.componentGroup.inactive': 'Không hoạt động',
  'pages.componentGroup.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.componentGroup.message.fixValidationErrors': 'Vui lòng sửa lỗi xác thực trước khi lưu',
  'pages.componentGroup.message.newRecordRemoved': 'Đã xóa bản ghi mới thành công',
  'pages.componentGroup.message.recordMarkedForDeletion': 'Bản ghi đã được đánh dấu để xóa. Nhấn Lưu để áp dụng thay đổi.',
  'pages.componentGroup.message.newRowAddedSuccessfully': 'Đã thêm hàng mới. Bắt đầu nhập để điền chi tiết.',
  'pages.componentGroup.message.multipleRowsAdded': 'Đã thêm {count} hàng. Bắt đầu nhập để điền chi tiết.',
  'pages.componentGroup.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.componentGroup.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.componentGroup.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.componentGroup.message.fetchError': 'Không thể tải dữ liệu nhóm thành phần',
  'pages.componentGroup.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.componentGroup.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.componentGroup.refresh.confirm': 'Bạn có {count} thay đổi chưa lưu. Làm mới sẽ hủy bỏ tất cả thay đổi. Bạn có chắc chắn muốn tiếp tục?',
  'pages.componentGroup.refresh.tooltip': 'Làm mới sẽ hủy bỏ {count} thay đổi chưa lưu',
  'pages.componentGroup.refresh.tooltip.normal': 'Làm mới dữ liệu từ máy chủ',

  'common.yes': 'Có',
  'common.no': 'Không',

  // ---- i18n audit 2026-09-03: fill missing keys (had defaultMessage fallbacks, silenced console warnings) ----
  'pages.UOM.title': 'Chi tiết đơn vị đo',
  'pages.accountgroup.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.address.column.level': 'Cấp',
  'pages.address.column.parent': 'Cấp cha',
  'pages.address.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.address.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.address.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.address.select.parent.placeholder': 'Chọn cấp cha (cấp thấp hơn)',
  'pages.address.validation.levelRequired': 'Vui lòng nhập cấp',
  'pages.address.validation.parentRequired': 'Cấp cha là bắt buộc khi cấp > 1',
  'pages.address.validation.tooltip': 'Sửa các trường bắt buộc (mã, tên, cấp, cấp cha khi cấp > 1)',
  'pages.addressDetail.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.addressDetail.message.childRecordCreated': 'Đã tạo bản ghi con với địa chỉ mặc định. Bạn có thể chỉnh sửa bên dưới.',
  'pages.addressDetail.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.addressDetail.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.addressDetail.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.addressDetail.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.addressDetail.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.addressDetail.message.newRowAddedSuccessfully': 'Đã thêm dòng mới (cùng cấp). Bắt đầu nhập để điền thông tin.',
  'pages.addressDetail.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.addressDetail.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.brand.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.brand.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.brand.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.calendar.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.calendar.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.calendar.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.calendar.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.calendarCustomize.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.calendarCustomize.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.calendarCustomize.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.calendarcustomize.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.category.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.category.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.color.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.color.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.color.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.component.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.component.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.componentGroup.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.componentGroup.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.currency.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.currency.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.currency.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.customer.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.customer.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.customer.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.customer.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.customerType.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.customerType.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.customerType.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.customertype.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.deliveryTerm.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.deliveryTerm.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.deliveryTerm.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.deliveryterm.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.employee.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.employee.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.employee.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.employee.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.employee.personInCharge.select': 'Chọn loại',
  'pages.employeeType.active': 'Đang hoạt động',
  'pages.employeeType.column.code': 'Mã',
  'pages.employeeType.column.isActive': 'Trạng thái',
  'pages.employeeType.column.name': 'Tên',
  'pages.employeeType.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.employeeType.inactive': 'Không hoạt động',
  'pages.employeeType.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.employeeType.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.employeeType.message.fetchError': 'Không thể tải danh sách loại nhân viên',
  'pages.employeeType.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.employeeType.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.employeeType.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.employeeType.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.employeeType.message.recordMarkedForDeletion': 'Đã đánh dấu xóa. Nhấn Lưu để áp dụng.',
  'pages.employeeType.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.employeeType.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.employeeType.title': 'Chi tiết loại nhân viên',
  'pages.employeeType.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.employeeType.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.employeetype.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.holiday.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.holiday.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.holiday.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.jobPosition.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.jobPosition.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.lightSource.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.lightSource.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.line.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.line.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.line.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.machine.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.machine.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.machine.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.machineType.active': 'Đang hoạt động',
  'pages.machineType.column.code': 'Mã',
  'pages.machineType.column.isActive': 'Trạng thái',
  'pages.machineType.column.name': 'Tên',
  'pages.machineType.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.machineType.inactive': 'Không hoạt động',
  'pages.machineType.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.machineType.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.machineType.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.machineType.message.fetchError': 'Không thể tải danh sách loại máy',
  'pages.machineType.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.machineType.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.machineType.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.machineType.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.machineType.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.machineType.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.machineType.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.machineType.title': 'Chi tiết loại máy',
  'pages.machineType.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.machineType.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.machinetype.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.materialType.active': 'Đang hoạt động',
  'pages.materialType.button.syncWfx': 'Đồng bộ WFX',
  'pages.materialType.column.code': 'Mã',
  'pages.materialType.column.isActive': 'Trạng thái',
  'pages.materialType.column.name': 'Tên',
  'pages.materialType.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.materialType.inactive': 'Không hoạt động',
  'pages.materialType.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.materialType.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.materialType.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.materialType.message.fetchError': 'Không thể tải danh sách loại vật liệu',
  'pages.materialType.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.materialType.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.materialType.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.materialType.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.materialType.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.materialType.message.syncWfxFailed': 'Không thể đồng bộ loại vật liệu từ WFX',
  'pages.materialType.message.syncWfxSuccess': 'Đồng bộ loại vật liệu từ WFX thành công',
  'pages.materialType.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.materialType.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.materialType.title': 'Loại vật liệu',
  'pages.materialType.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.materialType.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.operationLibrary.active': 'Đang hoạt động',
  'pages.operationLibrary.column.code': 'Mã',
  'pages.operationLibrary.column.isActive': 'Trạng thái',
  'pages.operationLibrary.column.level': 'Cấp',
  'pages.operationLibrary.column.name': 'Tên',
  'pages.operationLibrary.column.parent': 'Cấp cha',
  'pages.operationLibrary.delete.confirm': 'Bạn có chắc chắn muốn xóa bản ghi này?',
  'pages.operationLibrary.inactive': 'Không hoạt động',
  'pages.operationLibrary.message.changesSyncedSuccessfully': 'Đồng bộ thay đổi thành công',
  'pages.operationLibrary.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.operationLibrary.message.failedToSyncChanges': 'Không thể đồng bộ thay đổi',
  'pages.operationLibrary.message.fetchError': 'Không thể tải danh sách thư viện công đoạn',
  'pages.operationLibrary.message.fixValidationErrors': 'Vui lòng sửa lỗi trước khi lưu',
  'pages.operationLibrary.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.operationLibrary.message.newRecordRemoved': 'Đã xóa bản ghi mới',
  'pages.operationLibrary.message.newRowAddedSuccessfully': 'Đã thêm dòng mới. Bắt đầu nhập để điền thông tin.',
  'pages.operationLibrary.message.noChangesToSync': 'Không có thay đổi để đồng bộ',
  'pages.operationLibrary.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.operationLibrary.refresh.error': 'Không thể làm mới dữ liệu. Vui lòng thử lại.',
  'pages.operationLibrary.refresh.success': 'Làm mới dữ liệu thành công.',
  'pages.operationLibrary.select.parent.placeholder': 'Chọn cấp cha (cấp thấp hơn)',
  'pages.operationLibrary.title': 'Thư viện công đoạn',
  'pages.operationLibrary.validation.codeRequired': 'Vui lòng nhập mã',
  'pages.operationLibrary.validation.levelRequired': 'Vui lòng nhập cấp',
  'pages.operationLibrary.validation.nameRequired': 'Vui lòng nhập tên',
  'pages.operationLibrary.validation.parentRequired': 'Cấp cha là bắt buộc khi cấp > 1',
  'pages.operationLibrary.validation.tooltip': 'Sửa các trường bắt buộc (mã, tên, cấp, cấp cha khi cấp > 1)',
  'pages.organization.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.organization.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.organization.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.organizationDetail.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.organizationDetail.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.origin.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.origin.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.paymentTerm.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.paymentTerm.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.paymentterm.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.port.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.port.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.port.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.product.column.categoryId': 'Danh mục',
  'pages.product.column.colorIds': 'Màu sắc',
  'pages.product.column.shrinkage': 'Độ co rút',
  'pages.product.column.sizeIds': 'Kích thước',
  'pages.product.column.stitchCount': 'Số mũi',
  'pages.product.column.yarnCount': 'Chi số sợi',
  'pages.product.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.product.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.product.refresh.warning': 'Đã lưu dữ liệu nhưng làm mới thất bại. Vui lòng làm mới thủ công.',
  'pages.productCategory.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.productCategory.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.productGroup.column.category': 'Danh mục',
  'pages.productGroup.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.productGroup.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.section.column.allowedCategories': 'Danh mục cho phép',
  'pages.section.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.section.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.section.placeholder.allowedCategories': 'Chọn danh mục sản phẩm cho phép',
  'pages.shipmentTerm.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.shipmentTerm.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.shipmentterm.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.site.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.site.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.site.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.size.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.size.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.size.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.subCategory.column.productGroup': 'Nhóm sản phẩm',
  'pages.subCategory.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.subCategory.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.supplier.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.supplier.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.supplier.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.supplierType.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.supplierType.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
  'pages.suppliertype.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.uom.message.failedToDelete': 'Xóa bản ghi thất bại',
  'pages.uom.message.multipleRowsAdded': 'Đã thêm {count} dòng. Bắt đầu nhập để điền thông tin.',
  'pages.uom.message.recordDeletedSuccessfully': 'Xóa bản ghi thành công',
};
